module.exports = __webpack_public_path__ + "static/media/insta.9b32444e.png";